exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-teeth[data-v-f6ebe8f6]{margin-top:7px}.modal-header[data-v-f6ebe8f6]{padding-bottom:0!important}.modal-body[data-v-f6ebe8f6]{padding-top:0!important}.customer-name[data-v-f6ebe8f6]{margin-bottom:16px;font-size:16px;line-height:1.25;color:var(--theme-text-color)}.status-check[data-v-f6ebe8f6]{flex:0 0 120px}", ""]);

// exports
